import { render, staticRenderFns } from "./viewMessageType.vue?vue&type=template&id=68f5f5c7&"
import script from "./viewMessageType.vue?vue&type=script&lang=js&"
export * from "./viewMessageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCheckbox,VCol,VForm,VRow,VSelect,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68f5f5c7')) {
      api.createRecord('68f5f5c7', component.options)
    } else {
      api.reload('68f5f5c7', component.options)
    }
    module.hot.accept("./viewMessageType.vue?vue&type=template&id=68f5f5c7&", function () {
      api.rerender('68f5f5c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Notification/MessageType/components/viewMessageType.vue"
export default component.exports